import React, { Component } from 'react';
import Header from './components/Header/Header';
import Main from './components/Main/Main';
import Footer from './components/Footer/Footer';
import { urlPath, CURRENT_AUTH_VERSION } from './constants.js';

class App extends Component {
    async componentDidMount() {
        try {
            const techtop_auth_version = localStorage.getItem("techtop_auth_version");
            const hasReloaded = localStorage.getItem("hasReloadedOnce"); // 🧠 prevent reload loop
            console.log("Stored auth version:", techtop_auth_version);

            // Case 1: No version found
            if (techtop_auth_version === null && !hasReloaded) {
                console.log("No auth version found — logging out user...");
                localStorage.clear();
                localStorage.setItem("hasReloadedOnce", "true");
                window.location.reload();
                return;
            }

            // Case 2: Version mismatch
            if (techtop_auth_version !== CURRENT_AUTH_VERSION && !hasReloaded) {
                console.log("Auth version changed — logging out user...");
                localStorage.clear();
                localStorage.setItem("hasReloadedOnce", "true");
                window.location.reload();
                return;
            }

            // ✅ Reset reload flag after successful load
            localStorage.removeItem("hasReloadedOnce");
        } catch (error) {
            console.error("Error checking auth version:", error);
            localStorage.clear();
        }

        // 🎨 Your existing dynamic CSS loading
        const loadStyles = async () => {
            if (urlPath === 'user/my-account' || urlPath === 'user/order-history' || urlPath === 'user/open-orders') {
                await import('./css/user/custom.css');
                await import('./css/user/responsive.css');
            } else if (urlPath === '' || urlPath === '/' || urlPath === 'products' || urlPath === 'products/' || urlPath.startsWith('downloads/')) {
                await import('./css/new-custom.css');
                await import('./css/new-responsive.css');
            } else {
                await import('./css/custom.css');
                await import('./css/responsive.css');
            }
            await import('./css/footer.css');
        };
        loadStyles();
    }

    render() {
        return (
            <div className="App">
                <Header />
                <Main />
                <Footer />
            </div>
        );
    }
}

export default App;